import Button from 'components/ui/button';
import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';
import { useAuth } from 'context/AuthContext';
import { QuizType, finishQuiz, getQuizQuestions, sendQuestions, startQuiz, verifyQuiz } from 'services/quiz.service';
import FeedbackImg from '../../assets/img/comportamento/bg-feedback-moedas.png';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { actionLog } from 'services/actionlog.service';

interface MatrizProps {
  onClose: () => void;
  setQuizAnswered: () => void;
}

const quizId = 'rules';
const actionId = 'answer_quiz';

export default function Quiz({ onClose, setQuizAnswered }: MatrizProps) {
  const { userInfo, refreshUser } = useAuth();

  const [step, setStep] = useState(0);
  const [stepQuiz, setStepQuiz] = useState(0);
  const [quizLogId, setQuizLogId] = useState<string>('');
  const [questions, setQuestions] = useState<[QuizType]>();
  const [answers, setAnswers] = useState<any>([]);
  const [result, setResult] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [answerItem, setAnswerItem] = useState<any>([]);

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      if (!!userInfo?.chave) {
        const data = await startQuiz(userInfo.chave, quizId);
        setQuizLogId(data.log._id);
        const resp = await getQuizQuestions(quizId);

        const _answers: any = [];
        const _answerItem: any = [];

        resp?.forEach((e: any, index) => {
          if (e.log) {
            _answers[index] = e.log.answer[0];
            _answerItem[index] = e.log.extra.correct;
          }
        });

        setAnswerItem(_answerItem);
        setAnswers(_answers);

        setQuestions(resp);

        setLoading(false);
      }
    }

    async function isQuizDone() {
      const data = await verifyQuiz(quizId);
      if (data?.length > 0) {
        setStep(2);
      }
      setLoading(false);
    }

    if (userInfo?.chave && step === 1) {
      loadData();
    } else if (userInfo?.chave && step === 0) {
      isQuizDone();
    }
  }, [userInfo, step]);

  const handleChange = (index: number, e: any) => {
    const newAnswers = [...answers];
    newAnswers[index] = e.target.value;
    setAnswers(newAnswers);

    sendQuestion(index, newAnswers[index]);
  };

  async function sendQuestion(index: number, answer: any) {
    if (!userInfo?.chave) return;

    const payload = [
      {
        player: userInfo.chave,
        question: questions?.[index]._id,
        answer: [answer],
        quiz: quizId,
        quiz_log: quizLogId,
        extra: {
          correct: null,
        },
      },
    ];

    const _question = await sendQuestions(payload);
    if (_question?.registered?.[0]?.log?.extra?.correct) {
      const newAnswers = [...answerItem];
      newAnswers[index] = _question?.registered?.[0]?.log?.extra?.correct;
      setAnswerItem(newAnswers);
    }
  }

  async function sendQuiz() {
    if (!userInfo?.chave) return;
    setLoading(true);

    const resp = await finishQuiz(quizLogId);

    // await actionLog(userInfo?.chave, actionId, {
    //   quizLog: quizLogId,
    //   answered: true,
    // });

    setQuizAnswered();
    setResult(resp);
    setStep(2);

    refreshUser();
    setLoading(false);
  }

  function getText() {
    const value = Number(result?.log?.grade?.toFixed(1));
    if (value <= 2.8) {
      return {
        text: 'Não Bonificar',
        description: (
          <p className="text-base leading-none">
            Esta entrega recebeu nota <b>{value}</b>. Pelas respostas selecionadas na matriz, isso significa que talvez essa
            entrega <br />
            <br /> <b>não tenha atendido às expectativas para bonificação.</b>.
          </p>
        ),
      };
    } else if (value > 2.8 && value < 4) {
      return {
        text: 'Passível de bonificação',
        description: (
          <p className="text-base leading-none">
            Esta entrega recebeu nota <b>{value}</b>. Pelas respostas selecionadas na matriz, isso significa que a entrega <br />
            <br /> pode ser <b>bonificada</b>.
          </p>
        ),
      };
    } else if (value >= 4) {
      return {
        text: 'Passível de bonificação e promoção',
        description: (
          <p className="text-base leading-none">
            Esta entrega recebeu nota <b>{value}</b>. Pelas respostas selecionadas na matriz, isso significa que a entrega <br />
            <br /> pode ser <b>bonificada</b> e até mesmo <b>promovida</b>.
          </p>
        ),
      };
    }
  }

  return (
    <div className="fixed bg-black bg-opacity-40 top-0 left-0 w-screen h-screen p-6 pt-[10vh] flex justify-center overflow-y-auto z-50">
      <div className="relative border-2 border-solid border-electric-blue bg-oxford-blue rounded-lg p-8 w-[90%] lg:min-w-[650px] md:w-auto max-w-[1036px] h-fit">
        <Button
          color="primary"
          className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
          onClick={() => (!loading ? onClose() : null)}
        >
          <IoIosClose color="white" size={30} />
        </Button>

        {!!loading && (
          <div className="space-y-3 w-full md:w-[555px]">
            <>
              <ArticlePlaceholder />
              <ArticlePlaceholder />
              <ArticlePlaceholder />
              <ArticlePlaceholder />
            </>
          </div>
        )}

        {step === 0 && !loading && (
          <div className="space-y-8 text-base font-thin mx-8 w-full md:w-[556px]">
            <h1 className="text-yellow text-center leading-none font-bold text-lg">Quiz Regras do Programa</h1>

            <p>Selecionamos perguntas com as Regras da FLAP 360°. Responda cada uma delas com base no seu entendimento.</p>

            <div className="flex justify-center">
              <Button color="primary" className="uppercase py-2 text-sm" onClick={() => setStep(1)}>
                INICIAR QUIZ
              </Button>
            </div>
          </div>
        )}

        {step === 1 && !loading && (
          <div className="space-y-8 text-base font-thin">
            <h1 className="text-yellow text-center leading-none font-bold text-lg">Quiz Regras do Programa</h1>

            <div className="relative flex flex-row items-center justify-around mx-4">
              <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-white opacity-20"></div>
              {questions?.map((e, index) => (
                <div
                  className={`${
                    stepQuiz === index ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                  } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                >
                  {index + 1}
                </div>
              ))}

              {/* <div
                className={`${
                  stepQuiz === 4 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
              >
                5
              </div> */}
            </div>

            <div className="mx-4">
              {/* <p className="font-bold">
                Tema: <span className="text-electric-blue">{questions?.[stepQuiz]?.title}</span>
              </p>

              <p>Selecione a opção que mais se aplica a entrega diante do seguinte cenário:</p> */}

              <p>{questions?.[stepQuiz]?.question}</p>
            </div>

            <div className={`bg-oxford-blue-2 rounded-lg p-4 text-xs space-y-6 lg:text-md`}>
              {questions?.[stepQuiz]?.choices.map(choice => (
                <div key={choice.label} className="radio-button">
                  <input
                    type="radio"
                    className="radio-button-input "
                    name={`${stepQuiz}`}
                    id={choice.label}
                    value={choice.answer}
                    onChange={(e: any) => handleChange(stepQuiz, e)}
                    checked={answers[stepQuiz] === choice.answer}
                    disabled={!!answers[stepQuiz] && answers[stepQuiz] !== choice.answer}
                  />
                  <label
                    htmlFor={choice.label}
                    className={`${!!answerItem[stepQuiz] && answerItem[stepQuiz] === choice.answer ? 'correct-radio' : ''}
                    ${
                      !!answerItem[stepQuiz] && answerItem[stepQuiz] !== choice.answer && answers[stepQuiz] === choice.answer
                        ? 'wrong-radio'
                        : ''
                    }
                    ${
                      !!answers[stepQuiz] && answers[stepQuiz] !== choice.answer ? 'disabled-radio' : ''
                    } radio-button-label text-base`}
                  >
                    {choice.label}
                  </label>
                </div>
              ))}
            </div>

            <div className="flex lg:block justify-center">
              <div className="p-2 px-45 flex flex-row space-x-8 items-center justify-center">
                {stepQuiz > 0 && (
                  <button
                    onClick={() => setStepQuiz(stepQuiz - 1)}
                    className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                  >
                    <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                  </button>
                )}
                <button
                  onClick={() => {
                    if (questions && stepQuiz < questions?.length - 1) {
                      setStepQuiz(stepQuiz + 1);
                    } else {
                      sendQuiz();
                    }
                  }}
                  disabled={!answers[stepQuiz]}
                  className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                >
                  <p className="font-bold text-sm leading-none uppercase">Continuar</p>
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 2 && !loading && (
          <div className="text-center space-y-8 w-full md:w-[566px] mx-8">
            <img className="h-[155px] mx-auto" src={FeedbackImg} alt="Imagem de feedback" />

            <div className="text-lg">
              <p>Quiz Regras do Programa:</p>
              <p className="text-yellow font-bold mt-0">Concluído!</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
